import React, { useState } from 'react';
import PaymentLinksModal from '../modals/PaymentLinksModal';
import '../../styles/group/CharityBox.css';

const CharityBox = ({ groupId, isMember }) => {
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  // Only show for members, not admins
  if (!isMember) {
    return null;
  }

  const handleCharityClick = () => {
    setShowPaymentModal(true);
  };

  const handleClosePaymentModal = () => {
    setShowPaymentModal(false);
  };

  return (
    <>
      <div className="charity-box-floating" onClick={handleCharityClick}>
        <img 
          src="https://xvhellooihpelwifxuik.supabase.co/storage/v1/object/public/assets//TzedakahIcon.png" 
          alt="Charity Box" 
          className="charity-icon"
        />
      </div>

      {/* PaymentLinksModal for group donations */}
      <PaymentLinksModal
        isOpen={showPaymentModal}
        onClose={handleClosePaymentModal}
        groupId={groupId}
        isGroupDonation={true}
        isPaymentFlow={true}
      />
    </>
  );
};

export default CharityBox;